import { PLAN_TYPES } from 'containers/App/constants'
import {
  selectActualLicenses,
  selectLastProductRelease,
  selectLastSeenProductRelease,
} from 'containers/App/selectors'

import { Help, IronscalesConnect, Message, ProductUpdates } from 'components/lib/DesignSystem/Icons'

export const selectHelpMenuItems = (state) => {
  const planIsStarter = selectActualLicenses(state).plan === PLAN_TYPES.STARTER
  const lastProductRelease = selectLastProductRelease(state)
  const items = []
  if (!planIsStarter) {
    items.push({
      name: 'Help Center',
      Icon: Help,
      url: 'https://support.ironscales.com/hc/en-us',
    })
  }
  items.push({
    name: 'IRONSCALES Discord',
    Icon: IronscalesConnect,
    url: 'https://secure.ironscales.com/discord-community-access-request',
  })
  if (lastProductRelease) {
    items.push({
      name: 'Product Updates',
      Icon: ProductUpdates,
      url: 'https://support.ironscales.com/hc/en-us/sections/4431714789660-Release-Notes',
      showRedIndication:
        lastProductRelease?.created &&
        new Date(selectLastSeenProductRelease(state)) < new Date(lastProductRelease.created),
    })
  }
  items.push({
    name: `${planIsStarter ? 'Contact Support' : 'Leave us a message'}`,
    Icon: Message,
    url: 'https://support.ironscales.com/hc/en-us/requests/new',
  })
  return items
}
